export const InvoiceCardStyles = ({ isMobileScreen }) => ({
    root: {
        backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? '#1E252F' : theme.backgroundColor.primary,
        p: isMobileScreen ? '10px' : '24px 48px',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        borderRadius: '12px',
        boxShadow: (theme) =>
            theme.palette.mode === 'dark'
                ? '0 2px 8px rgba(0,0,0,0.4)'
                : '0 2px 8px rgba(0,0,0,0.08)',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : '#FFFFFF'),
        border: (theme) => `1px solid ${theme.palette.mode === 'dark' ? '#394150' : '#E5E6EB'}`,
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: (theme) =>
                theme.palette.mode === 'dark'
                    ? '0 8px 24px rgba(0,0,0,0.6)'
                    : '0 8px 24px rgba(0,0,0,0.12)',
        },
    },
    logo: {
        height: 120,
        objectFit: 'contain',
        padding: '20px',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A3240' : '#f8f9fa'),
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
    },
    cardContent: {
        padding: '16px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: 600,
        marginBottom: '8px',
        color: (theme) => (theme.palette.mode === 'dark' ? '#F3F4F6' : '#1A1F36'),
    },
    cardDescription: {
        fontSize: '14px',
        color: (theme) => (theme.palette.mode === 'dark' ? '#9CA3AF' : '#6B7280'),
        marginBottom: '16px',
        flexGrow: 1,
    },
    connectButton: {
        textTransform: 'none',
        fontWeight: 500,
        borderColor: (theme) => (theme.palette.mode === 'dark' ? '#4B5563' : '#D1D5DB'),
        color: (theme) => (theme.palette.mode === 'dark' ? '#E5E7EB' : '#374151'),
        '&:hover': {
            borderColor: (theme) => (theme.palette.mode === 'dark' ? '#9CA3AF' : '#9CA3AF'),
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
        },
        marginTop: '20px',
    },
    header: {
        marginBottom: '24px',
        padding: isMobileScreen ? '16px' : '0 24px',
    },
    headerTitle: {
        fontSize: '20px',
        fontWeight: 600,
        color: (theme) => (theme.palette.mode === 'dark' ? '#F9FAFB' : '#111827'),
        marginBottom: '8px',
    },
    headerSubtitle: {
        fontSize: '14px',
        color: (theme) => (theme.palette.mode === 'dark' ? '#9CA3AF' : '#6B7280'),
    },
    content: {
        padding: isMobileScreen ? '16px' : '0 24px 24px',
    },
});

export const invoiceFiltersStyles = () => ({
    clearButton: {
        marginRight: '10px',
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
    },
    cancelButton: {
        color: 'white',
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
        borderRadius: '10px',
        textTransform: 'none',
    },
    deleteButton: {
        marginRight: '10px',
    },
    revertAllButton: {
        marginRight: '10px',
    },
    inputField: {
       '& .MuiOutlinedInput-root': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            '& input': {
                fontSize: 13,
                color: (theme) => theme.textColor.primary,
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },
            '&:hover fieldset': {
                borderColor: 'white',
                border: '1px solid #E5E6EB',
            },
            borderRadius: 2,
            '& fieldset': {
                borderColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            },
            '&.Mui-focused fieldset': {
                borderColor: (theme) => (theme.palette.mode === 'dark' ? 'white' : '#1976d2'),
            },
        }, 
       
    },
    dropdown: {
        '& .MuiInputBase-root': {
            '& input': {
                fontSize: 13,
                padding: '16px 14px',
                color: (theme) => theme.textColor.primary,
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },

            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'none'),
            '& textarea': {
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },
            '&:hover fieldset': {
                borderColor: '#6C727F',
                border: '1px solid #E5E6EB',
            },
            borderRadius: 2,
            '& fieldset': {
                borderColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            },
            boxShadow: (theme) => theme.boxShadow,
            '& li': {
                color: (theme) => theme.textColor.inputField,
                fontSize: '16px',
                fontWeight: 400,
            },
            backgroundImage: 'unset',
            border: (theme) => `1px solid ${theme.borderColor.inputField}`,
        },
    },
    datePicker: {
        '& .MuiInputBase-root': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            borderRadius: '8px',
            border: 'none',
            height: '48px',
            minHeight: '40px',
            fontSize: 13,
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: (theme) =>
                    `1px solid ${theme.palette.mode === 'dark' ? '#E5E6EB' : '#E5E6EB'}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .MuiSvgIcon-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        },
        '& .MuiInputBase-input::placeholder': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            opacity: 1,
            fontSize: 13,
        },
        width: '100%',
        '& .MuiInputLabel-root': { fontSize: '13px' },
        '& .MuiOutlinedInput-input': { fontSize: '13px' },
    },
    countWrapper: {
        display: 'flex',
        marginBottom: '5px',
        justifyContent: 'flex-end',
    },
    applyButton: {
        marginLeft: '10px',
        '&.MuiButton-root': {
            marginLeft: '10px',
        },
    },
  
});

export const tabList = () => ({
    tabListStyling: {
        background: (theme) => (theme.palette.mode === 'dark' ? '#212936' : 'rgb(244, 244, 246)'),
        minHeight: '60px',
        borderRadius: '5px',
        padding: '1rem 2rem',
    },
});

export const invoiceStyles = ({ isMobileScreen }) => ({
    tabsListContainer: {
        width: '100%',
        background: (theme) => (theme.palette.mode === 'dark' ? '#212936' : 'white'),
        borderBottom: (theme) =>
            `1px solid ${theme.palette.mode === 'dark' ? '#394150' : '#E5E6EB'}`,
    },
    tabsContainer: {
        p: isMobileScreen ? '10px 10px' : '15px 15px',
    },
    stackStyles: {
        background: (theme) =>
            theme.palette.mode === 'dark' ? 'transparent' : 'rgb(244, 244, 246)',
        minHeight: '60px',
        borderRadius: '5px',
        padding: '1rem 2rem',
    },
});

export const credentailStyles = () => ({
    root: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: 3,
        width: '100%',
    },
});

export const integrationModalStyles = () => ({
    datePicker: {
        '& .MuiInputBase-root': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : '#F4F4F6'),
            borderRadius: '8px',
            border: 'none',
            height: '48px',
            minHeight: '40px',
            fontSize: 13,
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: (theme) =>
                    `1px solid ${theme.palette.mode === 'dark' ? '#E5E6EB' : '#E5E6EB'}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .MuiSvgIcon-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        },
        '& .MuiInputBase-input::placeholder': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            opacity: 1,
            fontSize: 13,
        },
        width: '100%',
        marginTop: '17px',
    },
});

export const uploadFileTabStyles = () => ({
    wrapper: {
        background: (theme) => (theme.palette.mode == 'dark' ? '#212936' : 'white'),
        padding: '24px',
        borderRadius: '12px',
    },
    buttonsWrapper: {
        display: 'flex',
        gap: '20px',
        marginTop: '20px',
        justifyContent: 'flex-end',
    },
    button: {
        color: 'white',
    },
    dropdownsWrapper: {
        display: 'flex',
        gap: '20px',
        width: '100%',
        marginBlock: '10px',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    clearButton: {
        color: 'white',
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
    },
    joyRideTour: {
        beacon: {
            inner: {
                backgroundColor: '#3f51b5',
            },
            outer: {
                backgroundColor: '#3f51b5',
                borderColor: '#3f51b5',
            },
        },
    },
});

export const paymentsSummaryStyles = () => ({
    root: {
        width: '100%',
        border: (theme) => `1px solid ${theme.palette.mode === 'dark' ? '#212936' : '#E5E6EB'} `,
        borderRadius: '15px',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : 'white'),
        padding: '16px 24px',
        boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '20px',
    },
    statbox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
    statBoxTitle: {
        variant: 'h6',
        fontWeight: 600,
        color: '#0061DB',
        marginBottom: 0.5,
    },
    statBoxLabel: {
        textTransform: 'uppercase',
        fontWeight: 500,
    },
    dividerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    divider: {
        height: '60px',
        borderColor: '#ccc',
        borderWidth: '1px',
    },
    buttonWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        textAlign: 'right',
    },
    button: {
        backgroundColor: '#0061DB',
        fontWeight: 600,
        textTransform: 'none',
        color: 'white',
        mb: 1,
        '&:hover': { backgroundColor: '#2076e0ff' },
    },
});

export const paymentActionModalStyles = () => ({
    cancelButton: {
        marginRight: '10px',
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
        padding: '10px 15px',
        width: '100px',
    },
    summaryWrapper: {
        p: 4,
        borderRadius: '8px',
        border: (theme) =>
            `1px solid ${theme.palette.mode === 'dark' ? 'transparent' : '#E5E6EB'} `,
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'transparent' : '#F9FAFB'),
        marginBottom: '20px',
    },
    actionWrapper: {
        p: 4,
        borderRadius: '8px',
        border: (theme) =>
            `1px solid ${theme.palette.mode === 'dark' ? 'transparent' : '#E5E6EB'} `,
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'transparent' : '#F9FAFB'),
    },
    matchButton: {
        backgroundColor: '#0061DB',
        fontWeight: 600,
        textTransform: 'none',
        color: 'white',
        '&:hover': { backgroundColor: '#2076e0ff' },
    },
    skipButton: {
        color: '#0061DB',
        fontWeight: 600,
        border: 'none',
        background: 'transparent',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
            color: '#2076e0ff',
            textDecoration: 'underline',
        },
    },
    findMatchBox: {
        mt: 2,
        color: '#0061DB',
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': { color: '#2076e0ff' },
    },
});
export const paymentFiltersStyles = () => ({
    clearButton: {
        marginRight: '10px',
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
    },
    cancelButton: {
        background: (theme) => theme.backgroundColor.primary,
        color: (theme) => theme.primary.dark,
        border: '1px solid #E5E6EB',
        '&:hover': {
            backgroundColor: (theme) => theme.backgroundColor.secondary,
        },
    },
    deleteButton: {
        marginRight: '10px',
    },
    revertAllButton: {
        marginRight: '10px',
    },
  
    inputField: {
        '& .MuiInputBase-root': {
            '& input': {
                fontSize: 13,
                padding: '16px 14px',
                color: (theme) => theme.textColor.primary,
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },

            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            '& textarea': {
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },
            '&:hover fieldset': {
                borderColor: '#6C727F',
                border: '1px solid #E5E6EB',
            },
            borderRadius: 2,
            '& fieldset': {
                borderColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            },
        },
    },
    dropdown: {
        '& .MuiInputBase-root': {
            '& input': {
                fontSize: 13,
                padding: '16px 14px',
                color: (theme) => theme.textColor.primary,
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },

            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'none'),
            '& textarea': {
                '&::placeholder': {
                    color: (theme) => theme.textColor.primary,
                    opacity: 1,
                    fontSize: 13,
                },
            },
            '&:hover fieldset': {
                borderColor: '#6C727F',
                border: '1px solid #E5E6EB',
            },
            borderRadius: 2,
            '& fieldset': {
                borderColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            },
            boxShadow: (theme) => theme.boxShadow,
            '& li': {
                color: (theme) => theme.textColor.inputField,
                fontSize: '16px',
                fontWeight: 400,
            },
            backgroundImage: 'unset',
            border: (theme) => `1px solid ${theme.borderColor.inputField}`,
        },
    },
    datePicker: {
        '& .MuiInputBase-root': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : 'white'),
            borderRadius: '8px',
            border: 'none',
            height: '48px',
            minHeight: '40px',
            fontSize: 13,
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: (theme) =>
                    `1px solid ${theme.palette.mode === 'dark' ? '#E5E6EB' : '#E5E6EB'}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .MuiSvgIcon-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        },
        '& .MuiInputBase-input::placeholder': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            opacity: 1,
            fontSize: 13,
        },
        width: '100%',
        '& .MuiInputLabel-root': { fontSize: '13px' },
        '& .MuiOutlinedInput-input': { fontSize: '13px' },
    },
    countWrapper: {
        display: 'flex',
        marginBottom: '5px',
        justifyContent: 'flex-end',
    },
});

